import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput'; // @ts-expect-error no types from package

import { isValidEmail } from '../../lib/LoginUtils';

const EmailInputForm = ({
  email,
  onEmailChange,
  submitting,
  useDark
}) => {
  const isValid = () => {
    return !!email && isValidEmail(email);
  };

  const [emailFocused, setEmailFocused] = useState(false);
  const error = email !== '' && !emailFocused && !isValid();
  return /*#__PURE__*/_jsx(UIFormControl, {
    htmlFor: "username",
    className: "m-bottom-4",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.form.email"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.smartLogin.emailHelp"
    }),
    error: error,
    validationMessage: error && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.formValidation.invalidEmail"
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "email-input-field",
      autoFocus: true,
      className: "login-email",
      disabled: submitting,
      id: "username",
      onBlur: () => setEmailFocused(false),
      onFocus: () => setEmailFocused(true),
      onChange: e => onEmailChange(e.target.value),
      tabIndex: 1,
      type: "email",
      value: email,
      use: useDark ? 'on-dark' : 'default'
    })
  });
};

EmailInputForm.propTypes = {
  useDark: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired
};
export default EmailInputForm;